import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const CaptchaScriptTag = (props) => {
    const {
        id,
        formId,
        src,
        dataCallback,
        languageCode
    } = props;

    const createScript = () => {
        const script = document.createElement('script');
        script.id = id;
        script.src = src;
        script.type = 'text/javascript';
        script.async = true;
        script.defer = true;

        if (dataCallback) {
            script.setAttribute('data-callback', dataCallback);
        }
        if (languageCode) {
            script.setAttribute('lang_code', languageCode);
        }

        const form = document.getElementById(formId);
        if (form !== null) {
            form.append(script);
        }

        return () => {
            const object = document.getElementById(id);
            object.remove();
        };
    };

    // create script tag once
    useEffect(() => createScript(props), []);

    return <></>;
};

CaptchaScriptTag.defaultProps = {
    dataCallback: null,
    languageCode: null
};

CaptchaScriptTag.propTypes = {
    id: PropTypes.string.isRequired,
    formId: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
    dataCallback: PropTypes.string,
    languageCode: PropTypes.string
};

export default CaptchaScriptTag;
